import React, { useEffect, useState } from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { makeStyles } from '@mui/styles';
import { Checkbox, FormControl, InputLabel, ListItemText } from '@mui/material';

const useStyles = makeStyles({
    select: {
        backgroundColor: '#33a9d5',
        borderRadius: '5px',
        color: '#ffffff',
        margin: '10px',
        fontWeight: 'bold',
        minWidth: '80px',
        width: '100%',
        minHeight: '35px',
    maxHeight: '45px',
        maxWidth: '250px',
        fontSize: '14px',
        '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
        },
        '& .MuiSelect-outlined': {
            color: 'white', fontWeight: 'bold',
        },
        '& .MuiSelect-icon': {
            color: 'white',
        },
    },
});

const MySelect = (props) => {
    const classes = useStyles(props);
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedType, setSelectedType] = useState(null);

    useEffect(() => {
        if (props.datas && props.value) {
            if (!props.multiple) {
                if (props.value !== '' && props.value !== []) {
                    if (selectedType === 'key') {
                        setSelectedItems([props.datas.find((d) => d.key === props.value)?.key]);
                    } else if (selectedType === 'id') {
                        setSelectedItems([props.datas.find((d) => d.id === props.value)?.id]);
                    } else {
                        setSelectedItems([props.value]);
                    }
                } else {
                    setSelectedItems([]);
                }
            } else {
                if (props.value.length > 0) {
                    if (selectedType === 'key') {
                        setSelectedItems(props.datas.filter((d) => props.value.includes(d.key)).map((d) => d.key));
                    } else if (selectedType === 'id') {
                        setSelectedItems(props.datas.filter((d) => props.value.includes(d.id)).map((d) => d.id));
                    } else {
                        setSelectedItems(props.value);
                    }
                } else {
                    setSelectedItems([]);
                }
            }
        } else {
            setSelectedItems([]);
        }
    }, [props.value]);

    const handleSelectOne = (event) => {
        const value = event.target.value;

        if (props.multiple) {
            const newValue = value.filter((v) => !selectedItems.includes(v));
            if (newValue.length === 0) {
                setSelectedItems(value);
                props.handleChange({
                    'target': {
                        'value': value,
                        'name': event.target.name,
                    },
                });
                return;
            }
            if (newValue[0] === 'all') {
                if (selectedItems.length === props.datas.length) {
                    setSelectedItems([]);
                    props.handleChange({
                        'target': {
                            'value': [],
                            'name': event.target.name,
                        },
                    });
                    return;
                }

                const newSelectedItems = [];
                if (selectedType === 'key') {
                    props.datas.map((d) => newSelectedItems.push(d.key));
                } else if (selectedType === 'id') {
                    props.datas.map((d) => newSelectedItems.push(d.id));
                } else {
                    props.datas.map((d) => newSelectedItems.push(d));
                }
                setSelectedItems(newSelectedItems);
                props.handleChange({
                    'target': {
                        'value': newSelectedItems,
                        'name': event.target.name,
                    },
                });
                return;
            }
            if (selectedItems.includes(newValue[0])) {
                const newSelectedItems = selectedItems.filter((s) => s !== newValue[0]);
                setSelectedItems(newSelectedItems);
                props.handleChange({
                    'target': {
                        'value': newSelectedItems,
                        'name': event.target.name,
                    },
                });
                return;
            }
            const newSelectedItems = [...selectedItems, newValue[0]];
            if (props.maxLength !== null && newSelectedItems.length > props.maxLength) {
                return;
            }
            setSelectedItems(newSelectedItems);
            props.handleChange({
                'target': {
                    'value': newSelectedItems,
                    'name': event.target.name,
                },
            });
            return;
        } else {
            if (selectedItems.includes(value)) {
                setSelectedItems([]);
                props.handleChange({
                    'target': {
                        'value': [],
                        'name': event.target.name,
                    },
                });
                return;
            }
            setSelectedItems([value]);
            props.handleChange({
                'target': {
                    'value': value,
                    'name': event.target.name,
                },
            });
            return;
        }
    };

    return (
        <FormControl style={props.formControlStyle ? props.formControlStyle : {}}>
            {props.displayLabel ? <InputLabel id={props.id + '-label'}
                                              className={props.labelClass ? props.labelClass : 'select-label-black'}>{props.label}</InputLabel> : ''}
            <Select className={props.disableClass ? '' : classes.select}
                    value={props.multiple ? props.value ? props.value : [] : props.value || ''}
                    multiple={props.multiple}
                    label={props.label}
                    style={props.style ? props.style : {maxWidth: '250px'}}
                    onChange={e => {
                        props.disabled ? null : handleSelectOne(e);props.handleChange;
                    }}
                    name={props.name}
                    labelId={props.id + '-label'}
                    id={props.id + '-select'}
                    sx={props.sx}
                    renderValue={(selected) => {
                        if (selected) {
                            if (props.datas) {
                                if (props.multiple) {
                                    if (selected.length === 0) {
                                        return props.firstValue ? props.firstValue.value : '-';
                                    }
                                    if (selected.length === props.datas.length) {
                                        return 'Tout';
                                    }
                                    if (selectedType === 'key') {
                                        return selected.map((s) => props.datas.find((d) => d.key === s).value).join(', ');
                                    } else if (selectedType === 'id') {
                                        return selected.map((s) => props.datas.find((d) => d.id === s).label).join(', ');
                                    } else {
                                        return selected.join(', ');
                                    }
                                } else {
                                    if (selectedType === 'key') {
                                        return props.datas.find((d) => d.key === selected)?.value;
                                    } else if (selectedType === 'id') {
                                        return props.datas.find((d) => d.id === selected)?.label;
                                    } else {
                                        return selected;
                                    }
                                }
                            }
                        }
                    }}
                    >
               {(props.multiple && props.datas.length > 0 && !props.maxLength) && (
                    <MenuItem value='all' key='all'>
                        <Checkbox checked={selectedItems.length === props.datas.length} />
                        <ListItemText primary='Sélectionner tout' />
                    </MenuItem>
                )}
                {props.datas.map((d) => {
                    if (d.key) {
                        if (selectedType === null) {
                            setSelectedType('key');
                        }
                        return <MenuItem value={d.key} key={d.id}><Checkbox
                            checked={selectedItems.length > 0 && selectedItems.includes(d.key)} /><ListItemText
                            primary={d.value} /></MenuItem>;
                    } else if (d.id) {
                        if (selectedType === null) {
                            setSelectedType('id');
                        }
                        return <MenuItem value={d.id} key={d.id}><Checkbox
                            checked={selectedItems.length > 0 && selectedItems.includes(d.id)} /><ListItemText
                            primary={d.label} /></MenuItem>;
                    } else {
                        if (selectedType === null) {
                            setSelectedType('value');
                        }
                        return <MenuItem value={d} key={d}><Checkbox
                            checked={selectedItems.length > 0 && selectedItems.includes(d)} /><ListItemText
                            primary={d} /></MenuItem>;
                    }
                })}
            </Select>
        </FormControl>
    );
};

export default MySelect;
